const FILTER_OPERATOR_OPTIONS = [
	{ label: "is", value: "is" },
	{ label: "is not", value: "is_not" },
	{ label: "is one of", value: "is_one_of" },
	{ label: "is not one of", value: "is_not_one_of" },
];

const DEFAULT_FILTER_OPERATORS = {
	product_vendor: "is_one_of",
	sales_channel: "is_not",
	product_type: "is_not_one_of",
};

const SITE_CONFIGS = {
	thor: {
		pageTitle: "Thor Live Sales",
		storeLabel: "THE HOUSE OF RARE",
		defaultVendors: ["ARTICALE", "RARE RABBIT", "THE HOUSE OF RARE"],
		defaultExcludedSalesChannels: ["Pragma"],
		defaultExcludedProductTypes: [
			"BOOTS",
			"LOAFER",
			"LOAFERS",
			"MULE",
			"SANDAL",
			"SHOES",
			"SNEAKER",
		],
		fallbackSalesChannels: [
			"Pragma",
			"Appmaker.xyz - Mobile app",
			"FastrrCheckoutV3",
			"Online Store",
			"None",
		],
		prioritizedSalesChannel: "Pragma",
	},
	rareism: {
		pageTitle: "Rareism Live Sales",
		storeLabel: "RAREISM",
		defaultVendors: ["RAREISM"],
		defaultExcludedSalesChannels: ["pragma_exchange"],
		defaultExcludedProductTypes: ["SHOES", "SANDAL"],
		fallbackSalesChannels: [
			"pragma_exchange",
			"pragma_refund",
			"Pragma",
			"Online Store",
			"None",
		],
		prioritizedSalesChannel: "pragma_exchange",
	},
};

export const getSiteConfig = (siteName = "thor") => {
	const key = String(siteName || "thor").toLowerCase();
	return SITE_CONFIGS[key] || SITE_CONFIGS.thor;
};

export { FILTER_OPERATOR_OPTIONS, DEFAULT_FILTER_OPERATORS };
